<template>
  <div id="AppsView" class="apps-view">
    <Header></Header>
    <b-container fluid>
      <b-row>
        <CompetitorLeftNav></CompetitorLeftNav>
        <b-col>
          <b-row class="justify-content-end mt-5 mb-3">
            <b-col sm="4">
              <b-form-group label="Select platform">
                <b-form-radio-group id="radios2" v-model="selected" name="radioSubComponent">
                  <b-form-radio value="ios" :disabled="isLoading">iOS</b-form-radio>
                  <b-form-radio value="android" :disabled="isLoading">Android</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </b-col>
            <b-col sm="2" class="text-right">
              <b-button variant="success" class="icon-container" @click.prevent="updateRatings" :disabled="isLoading">
                <i class="material-icons" :class="{ rotating: isLoading }">refresh</i>
                <span>Update</span>
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="pl-sm-5">
              <b-table striped
                :items="apps"
                :fields="fields"
                :filter="tableFilter"
                @sort-changed="sortingChanged"
                :sort-compare="compareRows"
                :sort-direction="sortDirection"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc">
                <template slot="avgRating" slot-scope="data">
                  <h6>
                    {{data.item.provider.name}}
                    <small>{{data.item.avgRating}}</small>
                  </h6>
                  <div v-if="data.item.avgRating > 4.8">
                    <i class="material-icons">star</i>
                    <i class="material-icons">star</i>
                    <i class="material-icons">star</i>
                    <i class="material-icons">star</i>
                    <i class="material-icons">star</i>
                  </div>
                  <div v-else-if="data.item.avgRating >= 4.3">
                    <i class="material-icons">star</i>
                    <i class="material-icons">star</i>
                    <i class="material-icons">star</i>
                    <i class="material-icons">star</i>
                    <i class="material-icons">star_half</i>
                  </div>
                  <div v-else-if="data.item.avgRating >= 3.8">
                    <i class="material-icons">star</i>
                    <i class="material-icons">star</i>
                    <i class="material-icons">star</i>
                    <i class="material-icons">star</i>
                    <i class="material-icons">star_border</i>
                  </div>
                  <div v-else-if="data.item.avgRating >= 3.3">
                    <i class="material-icons">star</i>
                    <i class="material-icons">star</i>
                    <i class="material-icons">star</i>
                    <i class="material-icons">star_half</i>
                    <i class="material-icons">star_border</i>
                  </div>
                  <div v-else-if="data.item.avgRating >= 2.8">
                    <i class="material-icons">star</i>
                    <i class="material-icons">star</i>
                    <i class="material-icons">star</i>
                    <i class="material-icons">star_border</i>
                    <i class="material-icons">star_border</i>
                  </div>
                  <div v-else-if="data.item.avgRating >= 2.3">
                    <i class="material-icons">star</i>
                    <i class="material-icons">star</i>
                    <i class="material-icons">star_half</i>
                    <i class="material-icons">star_border</i>
                    <i class="material-icons">star_border</i>
                  </div>
                  <div v-else-if="data.item.avgRating >= 1.8">
                    <i class="material-icons">star</i>
                    <i class="material-icons">star</i>
                    <i class="material-icons">star_border</i>
                    <i class="material-icons">star_border</i>
                    <i class="material-icons">star_border</i>
                  </div>
                  <div v-else-if="data.item.avgRating >= 1.3">
                    <i class="material-icons">star</i>
                    <i class="material-icons">star_half</i>
                    <i class="material-icons">star_border</i>
                    <i class="material-icons">star_border</i>
                    <i class="material-icons">star_border</i>
                  </div>
                  <div v-else-if="data.item.avgRating >= 0.8">
                    <i class="material-icons">star</i>
                    <i class="material-icons">star_border</i>
                    <i class="material-icons">star_border</i>
                    <i class="material-icons">star_border</i>
                    <i class="material-icons">star_border</i>
                  </div>
                  <div v-else-if="data.item.avgRating >= 0.3">
                    <i class="material-icons">star_half</i>
                    <i class="material-icons">star_border</i>
                    <i class="material-icons">star_border</i>
                    <i class="material-icons">star_border</i>
                    <i class="material-icons">star_border</i>
                  </div>
                  <div v-else>
                    <i class="material-icons">star_border</i>
                    <i class="material-icons">star_border</i>
                    <i class="material-icons">star_border</i>
                    <i class="material-icons">star_border</i>
                    <i class="material-icons">star_border</i>
                  </div>

                </template>
                <template slot="ratingCount" slot-scope="data">
                  <h6>{{data.item.ratingCount | formatNumber}}</h6>
                </template>
                <template slot="lastUpdated" slot-scope="data">
                  {{data.item.lastUpdated | formatDate}}
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import CompetitorLeftNav from '@/components/layout/CompetitorLeftNav'
import Header from '@/components/layout/Header'
import { mapActions, mapGetters } from 'vuex'
import { sortByDate, sort } from '@/util/sorting'
import { updateAppReviews } from '@/api/competitor'
export default {
  name: 'Apps',
  components: {
    CompetitorLeftNav,
    Header
  },
  async created () {
    await this.loadReviews()
  },
  methods: {
    ...mapActions({
      'fetchAppStoreReviews': 'competitor/fetchAppStoreReviews',
      'fetchPlayStoreReviews': 'competitor/fetchPlayStoreReviews'
    }),
    compareRows (a, b) {
      if (this.sortBy === 'lastUpdated') {
        return sortByDate(this.sortDesc, a.date, b.date)
      } else if (this.sortBy === 'avgRating') {
        return sort(this.sortDesc, a.avgRating, b.avgRating)
      } else if (this.sortBy === 'ratingCount') {
        return sort(this.sortDesc, a.ratingCount, b.ratingCount)
      }
    },
    sortingChanged (ctx) {
      this.sortBy = ctx.sortBy
      this.sortDesc = ctx.sortDesc
    },
    updateRatings () {
      updateAppReviews().then((response) => {
        this.$toastr.s('App ratings updated')
        this.loadReviews()
      })
    },
    async loadReviews () {
      if (this.selected === 'ios') {
        await this.fetchAppStoreReviews().catch(err => this.$toastr.e(err))
      } else {
        await this.fetchPlayStoreReviews().catch(err => this.$toastr.e(err))
      }
    }
  },
  watch: {
    selected: {
      handler () {
        this.loadReviews()
      }
    }
  },
  computed: {
    ...mapGetters({
      'apps': 'competitor/apps',
      'isLoading': 'loader/isLoading'
    })
  },
  data () {
    return {
      selected: 'ios',
      sortBy: 'avgRating',
      sortDesc: true,
      sortDirection: 'asc',
      tableFilter: null,
      fields: [
        { key: 'avgRating', label: 'App', sortable: true },
        { key: 'ratingCount', label: 'Ratings', sortable: true },
        { key: 'lastUpdated', label: 'Last updated', sortable: true }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/competitor/Apps.vue